var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.balance
  }, [_c('span', {
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.$t('payout.header.balance')) + ":")]), _c('span', {
    class: _vm.$style.amount
  }, [_vm._v(_vm._s(_vm.balance))])]), _c('div', {
    class: _vm.$style.payout
  }, [_c('div', {
    class: _vm.$style.amount
  }, [_vm._v(" " + _vm._s(_vm.available) + " ")]), _c('div', {
    class: _vm.$style.available,
    on: {
      "click": _vm.handleShownPayoutInfo
    }
  }, [_c('span', {
    class: _vm.$style.label
  }, [_vm._v(" " + _vm._s(_vm.$t('payout.header.available')) + " ")]), _c('span', {
    class: _vm.$style.icon
  }, [_c('info-icon', {
    directives: [{
      name: "fill",
      rawName: "v-fill:white",
      arg: "white"
    }]
  })], 1)])])]), _c('payout-info-dialog', {
    attrs: {
      "content": _vm.payoutInfoData
    },
    model: {
      value: _vm.isShownPayoutInfo,
      callback: function callback($$v) {
        _vm.isShownPayoutInfo = $$v;
      },
      expression: "isShownPayoutInfo"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }